
// import { useState, useMemo, useEffect } from "react";
// import { FiSearch, FiMenu, FiSun, FiMoon } from "react-icons/fi";
// import { useNavigate } from "react-router-dom";
// import LogoLight from "../../assets/netraaDocs_light.png";
// import LogoDark from "../../assets/netraaDocs_dark.png";
// import { sidebarMenu } from "../../data/sidebarMenu";

// export default function Header({ setActiveSection, onOpenSidebar }) {
//   const navigate = useNavigate();

//   // =================== Theme Toggle ===================
//   const toggleTheme = () => {
//     const html = document.documentElement;
//     html.classList.toggle("dark");
//     localStorage.theme = html.classList.contains("dark") ? "dark" : "light";
//   };

//   useEffect(() => {
//     if (
//       localStorage.theme === "dark" ||
//       (!("theme" in localStorage) &&
//         window.matchMedia("(prefers-color-scheme: dark)").matches)
//     ) {
//       document.documentElement.classList.add("dark");
//     }
//   }, []);

//   const contact = () => {
//     navigate("/contact");
//   };

//   // =================== Search State ===================
//   const [searchQuery, setSearchQuery] = useState("");
//   const [isDesktopDropdownOpen, setIsDesktopDropdownOpen] = useState(false);
//   const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);

//   // Flatten sidebar menu
//   const flatMenuItems = useMemo(() => {
//     const flatten = (items) => {
//       let result = [];
//       items.forEach((item) => {
//         if (item.section)
//           result.push({ title: item.title, id: item.section });
//         if (item.items)
//           result = result.concat(flatten(item.items));
//       });
//       return result;
//     };
//     return flatten(sidebarMenu);
//   }, []);

//   // Filter search
//   const filteredItems = useMemo(() => {
//     if (!searchQuery) return [];
//     return flatMenuItems.filter((item) =>
//       item.title.toLowerCase().includes(searchQuery.toLowerCase())
//     );
//   }, [searchQuery, flatMenuItems]);

//   // ESC closes search
//   useEffect(() => {
//     const handleEsc = (e) => {
//       if (e.key === "Escape") {
//         setIsDesktopDropdownOpen(false);
//         setIsMobileSearchOpen(false);
// }
//     };
//     window.addEventListener("keydown", handleEsc);
//     return () => window.removeEventListener("keydown", handleEsc);
//   }, []);

//   // Handle select
//   const handleSelect = (item) => {
//     setIsDesktopDropdownOpen(false);
//     setIsMobileSearchOpen(false);
//     setSearchQuery("");

//     if (setActiveSection) setActiveSection(item.id);

//     const el = document.getElementById(item.id);
//     if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
//   };

//   return (
//     <header className="header bg-white dark:bg-[#141414] border-b border-gray-200 dark:border-gray-800 px-4 lg:px-6">
//       <div className="flex items-center justify-between h-full">

//         {/* LEFT: LOGO */}
//         <div className="flex items-center gap-3 w-64">
//           <img
//             src={LogoLight}
//             alt="Light Logo"
//             className="h-10 w-auto dark:hidden lg:h-24 mt-3"
//           />
//           <img
//             src={LogoDark}
//             alt="Dark Logo"
//             className="h-10 w-auto hidden dark:block lg:h-24 mt-3"
//           />

//           <button
//             onClick={onOpenSidebar}
//             className="lg:hidden p-3 rounded-md dark:text-white"
//           >
//             <FiMenu className="text-xl" />
//           </button>
//         </div>

//         {/* CENTER: SEARCH */}
//         <div className="flex-1 flex justify-center px-4">
//           {/* Desktop */}
//           <div className="hidden md:flex relative w-full max-w-md">
//             <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />

//             <input
//   type="text"
//   placeholder="Search docs..."
//   autoComplete="off"
//   value={searchQuery}
//   onChange={(e) => {
//   const value = e.target.value;
//   setSearchQuery(value);
//   setIsDesktopDropdownOpen(!!value);
// }}
//   onKeyDown={(e) => {
//     if (e.key === "Enter" && filteredItems.length > 0) {
//       handleSelect(filteredItems[0]);
//     }
//   }}
// className="w-full pl-10 pr-4 py-2 rounded-md border 
//            bg-gray-50 text-black 
//            dark:bg-[#1f1f1f] dark:text-white 
//            border-gray-200 dark:border-gray-700
//            placeholder-gray-400 dark:placeholder-gray-500
//            focus:outline-none focus:ring-2 focus:ring-orange-500"
// />
//             {/* Dropdown */}
//             {isDesktopDropdownOpen && filteredItems.length > 0 && (
//               <div className="absolute top-full mt-2 w-full bg-white dark:bg-[#1f1f1f]
//                               border border-gray-200 dark:border-gray-700  text-black dark:text-white
//                               rounded-md shadow-lg z-50">
//                 {filteredItems.slice(0, 5).map((item, i) => (
//                   <div
//                     key={i}
//                     onClick={() => handleSelect(item)}
//                     className="px-4 py-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 text-sm"
//                   >
//                     {item.title}
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>

//           {/* Mobile Icon */}
//           <button
//             onClick={() => setIsMobileSearchOpen(true)}
//             className="md:hidden p-2 rounded-md hover:bg-gray-100 dark:text-white"
//           >
//             <FiSearch className="text-xl" />
//           </button>
//         </div>

//         {/* RIGHT */}
//         <div className="flex items-center gap-4 w-64 justify-end">
//           <button className="hidden sm:flex text-xs font-semibold 
//                    bg-gray-100 text-gray-700
//                    dark:bg-white/10 dark:text-white
//                    px-2.5 py-1.5 rounded-md
//                    border border-gray-200 dark:border-white/10">
//   v1.0
// </button>

//           {/* Theme Toggle */}
//           <button
//   onClick={toggleTheme}
//   aria-label="Toggle Dark Mode"
//   className="relative flex items-center w-10 h-6 sm:w-12 sm:h-7 
//              rounded-full bg-gray-300 dark:bg-orange-500 
//              transition px-1 overflow-hidden"
// >
//   {/* Knob */}
//   <span
//     className="w-4 h-4 sm:w-5 sm:h-5 bg-white rounded-full shadow-md 
//                transform transition-transform duration-300
//                flex items-center justify-center
//                translate-x-0 
//                dark:translate-x-2 sm:dark:translate-x-5"
//   > 
//     <FiSun className="text-orange-500 text-[10px] sm:text-xs dark:hidden" />
//     <FiMoon className="text-gray-700 text-[10px] sm:text-xs hidden dark:block" />
//   </span>
// </button>

//           <button
//             onClick={contact}
//             className="ml-3 px-3 py-1.5 text-xs font-semibold text-white rounded-full
//                        bg-gradient-to-r from-orange-500 via-orange-600 to-red-600"
//           >
//             Contact Now
//           </button>
//         </div>
//       </div>

//       {/* MOBILE SEARCH OVERLAY */}
//       {isMobileSearchOpen && (
//         <div className="fixed inset-0 bg-black/50 z-50 flex items-start justify-center pt-24 px-4 md:hidden">
//           <div className="w-full max-w-md bg-white dark:bg-[#1f1f1f] rounded-lg p-4">

//             <div className="relative">
//               <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />

//               <input
//                 autoFocus
//                 type="text"
//                 placeholder="Search docs..."
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter" && filteredItems.length > 0) {
//                     handleSelect(filteredItems[0]);
//                   }
//                 }}
//                 className="w-full pl-10 pr-4 py-2 rounded-xl border
//                            bg-gray-50 dark:bg-[#1f1f1f] text-black dark:text-white
//                            border-gray-200 dark:border-gray-700
//                            text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
//               />
//             </div>

//             {/* Results */}
//             <div className="mt-3 max-h-60 overflow-y-auto">
//               {filteredItems.map((item, i) => (
//                 <div
//                   key={i}
//                   onClick={() => handleSelect(item)}
//                   className="px-3 py-2 cursor-pointer rounded-md hover:bg-gray-100 dark:hover:bg-gray-800 text-sm text-black dark:text-white"
//                 >
//                   {item.title}
//                 </div>
//               ))}
//             </div>

//             <button
//               onClick={() => setIsMobileSearchOpen(false)}
//               className="mt-3 text-sm text-gray-500 hover:text-red-500"
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}
//     </header>
//   );
// }

import { useState, useMemo, useEffect } from "react";
import { FiSearch, FiMenu, FiSun, FiMoon } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import LogoLight from "../../assets/netraaDocs_light.png";
import LogoDark from "../../assets/netraaDocs_dark.png";
import { sidebarMenu } from "../../data/sidebarMenu";

export default function Header({ setActiveSection, onOpenSidebar }) {
  const navigate = useNavigate();

  // =================== Theme Toggle ===================
  const toggleTheme = () => {
    const html = document.documentElement;
    html.classList.toggle("dark");
    localStorage.theme = html.classList.contains("dark") ? "dark" : "light";
  };

  useEffect(() => {
    if (
      localStorage.theme === "dark" ||
      (!("theme" in localStorage) &&
        window.matchMedia("(prefers-color-scheme: dark)").matches)
    ) {
      document.documentElement.classList.add("dark");
    }
  }, []);

  const contact = () => {
    navigate("/contact");
  };

  // =================== Search State ===================
  const [searchQuery, setSearchQuery] = useState("");
  const [isDesktopDropdownOpen, setIsDesktopDropdownOpen] = useState(false);
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);

  // Flatten sidebar menu
  const flatMenuItems = useMemo(() => {
    const flatten = (items) => {
      let result = [];
      items.forEach((item) => {
        if (item.section) {
          result.push({
            title: item.title,
            id: item.section,
            path: item.path || `/${item.section}`,
          });
        }
        if (item.items) {
          result = result.concat(flatten(item.items));
        }
      });
      return result;
    };
    return flatten(sidebarMenu);
  }, []);

  // Filter search
// Filter search
const filteredItems = useMemo(() => {
  if (!searchQuery) return [];
  const query = searchQuery.toLowerCase();
  return flatMenuItems.filter(
    (item) =>
      item.title.toLowerCase().includes(query) ||
      item.id?.toLowerCase().includes(query)
  );
}, [searchQuery, flatMenuItems]);

  // ESC closes search
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setIsDesktopDropdownOpen(false);
        setIsMobileSearchOpen(false);
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  // Handle select
  const handleSelect = (item) => {
    setIsDesktopDropdownOpen(false);
    setIsMobileSearchOpen(false);
    setSearchQuery("");

    if (setActiveSection) setActiveSection(item.id);

    // NEW: update route so Sidebar can highlight the correct item
    if (item.path) {
      navigate(item.path);
    } else {
      navigate(`/${item.id}`);
    }

    // NEW: scroll to the selected section after navigation/rerender
    setTimeout(() => {
      const el = document.getElementById(item.id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  };

  return (
    <header className="header bg-white dark:bg-[#141414] border-b border-gray-200 dark:border-gray-800 px-4 lg:px-6">
      <div className="flex items-center justify-between h-full">
        {/* LEFT: LOGO */}
        <div className="flex items-center gap-3 w-64">
          <img
            src={LogoLight}
            alt="Light Logo"
            className="h-10 w-auto dark:hidden lg:h-24 mt-3"
          />
          <img
            src={LogoDark}
            alt="Dark Logo"
            className="h-10 w-auto hidden dark:block lg:h-24 mt-3"
          />

          <button
            onClick={onOpenSidebar}
            className="lg:hidden p-3 rounded-md dark:text-white"
          >
            <FiMenu className="text-xl" />
          </button>
        </div>

        {/* CENTER: SEARCH */}
        <div className="flex-1 flex justify-center px-4">
          {/* Desktop */}
          <div className="hidden md:flex relative w-full max-w-md">
            <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />

            <input
              type="text"
              placeholder="Search docs..."
              autoComplete="off"
              value={searchQuery}
              onChange={(e) => {
                const value = e.target.value;
                setSearchQuery(value);
                setIsDesktopDropdownOpen(!!value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" && filteredItems.length > 0) {
                  handleSelect(filteredItems[0]);
                }
              }}
              className="w-full pl-10 pr-4 py-2 rounded-md border 
                         bg-gray-50 text-black 
                         dark:bg-[#1f1f1f] dark:text-white 
                         border-gray-200 dark:border-gray-700
                         placeholder-gray-400 dark:placeholder-gray-500
                         focus:outline-none focus:ring-2 focus:ring-orange-500"
            />

            {/* Dropdown */}
            {isDesktopDropdownOpen && filteredItems.length > 0 && (
              <div
                className="absolute top-full mt-2 w-full bg-white dark:bg-[#1f1f1f]
                                border border-gray-200 dark:border-gray-700  text-black dark:text-white
                                rounded-md shadow-lg z-50"
              >
                {filteredItems.slice(0, 5).map((item, i) => (
                  <div
                    key={i}
                    onClick={() => handleSelect(item)}
                    className="px-4 py-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 text-sm"
                  >
                    {item.title}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Mobile Icon */}
          <button
            onClick={() => setIsMobileSearchOpen(true)}
            className="md:hidden p-2 rounded-md hover:bg-gray-100 dark:text-white"
          >
            <FiSearch className="text-xl" />
          </button>
        </div>

        {/* RIGHT */}
        <div className="flex items-center gap-4 w-64 justify-end">
          <button
            className="hidden sm:flex text-xs font-semibold 
                       bg-gray-100 text-gray-700
                       dark:bg-white/10 dark:text-white
                       px-2.5 py-1.5 rounded-md
                       border border-gray-200 dark:border-white/10"
          >
            v1.0
          </button>

          {/* Theme Toggle */}
          <button
            onClick={toggleTheme}
            aria-label="Toggle Dark Mode"
            className="relative flex items-center w-10 h-6 sm:w-12 sm:h-7 
                       rounded-full bg-gray-300 dark:bg-orange-500 
                       transition px-1 overflow-hidden"
          >
            {/* Knob */}
            <span
              className="w-4 h-4 sm:w-5 sm:h-5 bg-white rounded-full shadow-md 
                         transform transition-transform duration-300
                         flex items-center justify-center
                         translate-x-0 
                         dark:translate-x-2 sm:dark:translate-x-5"
            >
              <FiSun className="text-orange-500 text-[10px] sm:text-xs dark:hidden" />
              <FiMoon className="text-gray-700 text-[10px] sm:text-xs hidden dark:block" />
            </span>
          </button>

          <button
            onClick={contact}
            className="ml-3 px-3 py-1.5 text-xs font-semibold text-white rounded-full
                       bg-gradient-to-r from-orange-500 via-orange-600 to-red-600"
          >
            Contact Now
          </button>
        </div>
      </div>

      {/* MOBILE SEARCH OVERLAY */}
      {isMobileSearchOpen && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-start justify-center pt-24 px-4 md:hidden">
          <div className="w-full max-w-md bg-white dark:bg-[#1f1f1f] rounded-lg p-4">
            <div className="relative">
              <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />

              <input
                autoFocus
                type="text"
                placeholder="Search docs..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && filteredItems.length > 0) {
                    handleSelect(filteredItems[0]);
                  }
                }}
                className="w-full pl-10 pr-4 py-2 rounded-xl border
                           bg-gray-50 dark:bg-[#1f1f1f] text-black dark:text-white
                           border-gray-200 dark:border-gray-700
                           text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
              />
            </div>

            {/* Results */}
            <div className="mt-3 max-h-60 overflow-y-auto">
              {filteredItems.map((item, i) => (
                <div
                  key={i}
                  onClick={() => handleSelect(item)}
                  className="px-3 py-2 cursor-pointer rounded-md hover:bg-gray-100 dark:hover:bg-gray-800 text-sm text-black dark:text-white"
                >
                  {item.title}
                </div>
              ))}
            </div>

            <button
              onClick={() => setIsMobileSearchOpen(false)}
              className="mt-3 text-sm text-gray-500 hover:text-red-500"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </header>
  );
}